import {
  ChatMessageAttachmentType,
  ChatMessagePayloadAttachment,
} from "@jugl-web/rest-api";
import { useFilePreview } from "@jugl-web/domain-resources/files/providers/FilePreviewProvider";
import React, { useCallback } from "react";
import { EmailAttachmentCard } from "./components/EmailAttachmentCard";

export const EmailMessageAttachments: React.FC<{
  attachments: ChatMessagePayloadAttachment[];
}> = ({ attachments }) => {
  const { previewFile, previewFiles } = useFilePreview();

  // the media endpoint is publicly accessible, so we point preview/download
  // straight at the URL instead of fetching the blob and creating object URLs
  const handleDownload = useCallback(
    (attachment: ChatMessagePayloadAttachment) => {
      if (!attachment.url) {
        return;
      }

      const link = document.createElement("a");
      link.href = attachment.url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.download = attachment.name || "attachment";
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    []
  );

  const handlePreview = useCallback(
    (index: number) => {
      const configs = attachments.map((attachment) => ({
        url: attachment.url || "",
        name: attachment.name || "",
        mimeType: attachment.mimetype,
        size: attachment.size,
        preview:
          attachment.type === ChatMessageAttachmentType.image
            ? attachment.url
            : undefined,
        onDownload: () => handleDownload(attachment),
      }));

      if (configs.length === 1) {
        previewFile(configs[0]);
      } else {
        previewFiles(configs, configs[index].url);
      }
    },
    [attachments, handleDownload, previewFile, previewFiles]
  );

  return (
    <div className="flex flex-wrap gap-3 px-6 pb-5">
      {attachments.map((attachment, index) => (
        <EmailAttachmentCard
          key={attachment.uid}
          attachment={attachment}
          onClick={() => handlePreview(index)}
        />
      ))}
    </div>
  );
};
